<template>
    <div class="page">
        <ion-grid fixed v-if="displayContent">
            <form>
                <ion-row class="row-divider"></ion-row>
                <ion-row class="rectangle" >
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col class="col-padding">
                                <ion-label class="section-head">Payment Details</ion-label>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">Ref.no</ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    readonly="true"
                                    :value="userTransactionHistory.referenceNo"
                                ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                Bank Ref.no
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder
                                    readonly="true"
                                    :value="userTransactionHistory.bankReferenceNo"
                                ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                App Ref.no
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder
                                    maxlength="50"
                                    readonly="true"
                                    :value="userTransactionHistory.appReferenceNo"
                                ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                Amount
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder
                                        maxlength="50"
                                        readonly="true"
                                        :value="userTransactionHistory.amount"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                Remarks
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder
                                        maxlength="50"
                                        readonly="true"
                                        :value="userTransactionHistory.remarks"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                Payment Method
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder
                                        maxlength="50"
                                        readonly="true"
                                        :value="userTransactionHistory.paymentMethod"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                Created At
                                </ion-label>
                                <div class="border-line-34 readonly margin-top-10">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        placeholder
                                        maxlength="50"
                                        readonly="true"
                                        :value="userTransactionHistory.createdAt"
                                    ></ion-input>
                                </div>
                            </ion-col>
                        </ion-row>
                    </ion-col>
                </ion-row>
                <ion-row align-items-stretch>
                    <ion-col size="12" class="col-nopadding ion-text-right">
                        <ion-button id="lines-sharp" class="btn-primary margin-top-10" v-if = "disabledBtn"  @click="updatePaymentDetails">Update</ion-button>
                    </ion-col>
                </ion-row>
                
            </form>
        </ion-grid>
        <ion-grid v-if="!displayContent">
            <ion-row >
                <ion-col class="display-message">{{ message }}</ion-col>
            </ion-row>
        </ion-grid>
        <ion-grid>
            <ion-row>
                <ion-col>
                    <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..."></ion-loading>
                </ion-col>
            </ion-row>
        </ion-grid>
  </div>
</template>

<script>
import { IonCol, IonGrid, IonInput, IonLabel, IonLoading, IonRow, alertController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { ManageUserDetails} from "../../service/evcstation/manageUser.service";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
    name: 'manageUserEdit',
    components: {
        IonGrid, IonCol, IonRow, IonLabel, IonInput, IonLoading, alertController
    },
    data() {
        return {
            isLoading: false,
            transactionDetails: "",
            userId: '',
            orderId: '',
            userTransactionHistory: '',
            disabledBtn: false,
            message : "",
            displayContent : false
        }
    },
    mounted() {
        const selected = JSON.parse(localStorage.getItem("selectedTransaction"));
        this.transactionDetails = selected;
        this.userWalletHistory()
    },
    methods: {
        async userWalletHistory() {
            try {
                this.isLoading = true;
                var transactionHistory = await new ManageUserDetails().getPaymentDetailsFromRazorpay(this.transactionDetails);
                if(transactionHistory.paymentDetails) {
                    this.userTransactionHistory = transactionHistory.paymentDetails;
                    if(this.userTransactionHistory.status) {
                        this.disabledBtn = true;
                    }
                    this.displayContent = true;
                } else {
                    this.message = transactionHistory.message;
                    this.displayContent = false;
                }
                
                this.isLoading = false;
            } catch (error) {
               this.isLoading = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        async updatePaymentDetails() {
            const alert = await alertController.create({
                header: "Confirm",
                message: "Are you sure want to update the transaction",
                buttons: [
                    {
                        text: "NO",
                        role: "cancel",
                        cssClass: "secondary",
                        handler: () => {
                            console.log('cancel')
                        }
                    },
                    {
                        text: "YES",
                        handler: () => {
                            this.updateTransactionHistory()
                        }
                    }
                ]
            });
            await alert.present();
        },

        async updateTransactionHistory() {
            try { 
                this.isLoading = true;
                let updateTransaction = await new ManageUserDetails().updatePaymentDetailsFromRazorpay(this.userTransactionHistory)
                if(updateTransaction.appReferenceNo) {
                    this.$router.go(-1)
                }
                this.isLoading = false;
            } catch(err) {
                this.isLoading = false;
                let serviceError = migratedTryParseServiceError(err);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
      
    },
    
})
</script>

<style>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
ion-loading.custom-loading {
    --background: #d0cbcb;
    --spinner-color: #0bc954;
    color: #1a1b1c;
    --height: 7%;
}
.display-message {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10%;
    font-size: 16px;
    color: #041648;
}
</style>